<template>
<div class="add-device">
  <van-nav-bar title="添加设备" :fixed="true" left-text="返回" :border="false" left-arrow @click-left="backPage" />
  <p>温馨提示：</p>
  <p>您可在包装盒或设备上找到IMEI绑定号后手动输入或扫码绑定</p>
  <div class="imei-input">
    <van-field
    v-model="imei"
    placeholder="请输入设备IMEI"
    :border="false"
    type="number"
    :maxlength="15"
    />
    <img class="device-img" src="@/assets/images/saoyisao.png" background-size="cover" @click="toCamera()" />
  </div>
  <div class="btn-box">
    <van-button round type="info" @click="binding">绑定</van-button>
  </div>
</div>
</template>

<script>
import tokenVerify from '@/utils/lib/token-verify'; //token验证
export default {
  data () {
    return {
      imei:'',//用户输入imei
      childId:null,
    }
  },

  components: {
    
  },
  created(){
    if (this.$route.query.data) {
      this.childId = data.childId
    }
  },
  methods: {
    //跳转扫码页面
    toCamera(){
      if(/android/i.test(navigator.userAgent)){
        this.$router.push({ name: 'myCamera'});
      }
      if(/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)){
        this.$router.push({ name: 'myCamera1'});
      }
      // this.$router.push({ name: 'myCamera'});
    },
    //绑定imei
    binding(){
      let data = {
        ver:1,
        method:'shiNiuAddDevice',
        imei:this.imei,
        // childId:this.childId
      }
      this.$http.post(this.$api.userInfo.POST_APPLET,data).then(res => {
          if (res.code === 0) {
            tokenVerify(res.data.token)
            this.$router.push({ name: "location" });
          } else{
            this.$toast({
                message: res.msg,
                duration: 2000,
                icon: require('@/assets/images/safety-fence/wrong.png'),
            });
          }
      })
    },
    /**
     * 返回上一级
     */
    backPage() {
        this.$router.push({name:'deviceOption'});
    },
  },

  created () {
  },
}
</script>

<style lang="scss" scoped>
.add-device{
  padding: 100px 40px 0;
  >p {
    font-size: 28px;
    color: #999;
    margin-bottom: 10px;
  }
  .imei-input{
    display: flex;
    border: 1px solid #ccc;
    overflow: hidden;
    width: 650px;
    border-radius: 20px;
    padding-right: 15px;
    align-items: center;
    margin: 40px auto 0;
    .device-img{
      width: 80px;
      height: 60px;
    }
  }
}
.btn-box{
  width: 100%;
  padding: 20px 0 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
<style lang="scss">
.add-device .van-button{
  margin: 0 auto;
  border: none;
  width: 650px;
  height: 98px;
  border-radius: 20px;
  background-color: #01ADA9;
}

</style>
